import { Component, Input, OnInit } from '@angular/core';
import { STATE_BPPROFILES_INVOICEOVERVIEW } from '../../../../../shared/app-states';
import { BPProfilesService, BPProfilesViewCode } from '../../../bp-profiles.service';
import { GaDeferredService, IGADeferred } from '../../../../../shared/services/ga-deferred.service';
import { AuthService } from '../../../../../shared/services/auth/auth.service';
import { StateService, TransitionService } from '@uirouter/angular';
import { GaStateService } from '../../../../../shared/services/ga-state.service';
import { Override } from '../../../../../shared/app-decorators';
import { BaseBPProfilesDetailComponent } from '../../base-bp-profiles-detail.component';
import { EVENT_CANCEL_BP_INVOICE_TEMPLATE, EVENT_EDIT_BP_INVOICE_TEMPLATE, EVENT_SAVE_BP_INVOICE_TEMPLATE, InvoiceTemplatesService } from '../../../../../shared/invoice/templates/invoice-templates.service';
import { GaEventService } from '../../../../../shared/services/ga-event.service';
import { distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'bp-profiles-invoice-detail',
  template: `
    <invoice-template-detail
      [companyCountryId]="companyCountryId"
      [invoiceTemplateId]="invoiceTemplateId"
      overviewState="${STATE_BPPROFILES_INVOICEOVERVIEW}"
      (onSaved)="onInvoiceTemplateSaved()"
      (onCancel)="onInvoiceTemplateCancel()"
    ></invoice-template-detail>
  `
})
export class BPProfilesInvoiceDetailComponent extends BaseBPProfilesDetailComponent implements OnInit {
  @Input() public invoiceTemplateId:number;
  public companyCountryId:number;

  private onSavedDeferred:IGADeferred<void>;
  private onEditingChangeSubscription:Subscription;
  private onFormChangeSubscription:Subscription;
  private onStateExitHook:Function;

  constructor(
    private deferredService:GaDeferredService,
    private authService:AuthService,
    private gaStateService:GaStateService,
    private invoiceTemplatesService:InvoiceTemplatesService,
    private eventService:GaEventService,
    private transitionService:TransitionService,
    protected bpProfilesService:BPProfilesService,
    protected stateService:StateService
  ) {
    super(bpProfilesService, stateService);
    // set overview state and form state
    this.overviewState = STATE_BPPROFILES_INVOICEOVERVIEW;
  }

  @Override(BaseBPProfilesDetailComponent)
  public ngOnInit():void {
    this.gaStateService.screen = 'BPPROFILES.INVOICE';
    this.companyCountryId = this.bpProfilesService.activeProfile?.companyCountryId;

    if (!this.authService.viewWrite(BPProfilesViewCode.INVOICE)) {
      this.invoiceTemplatesService.editing = false;
    } else {
      this.bpProfilesService.editingMode = this.invoiceTemplatesService.editing;
    }

    // register listener
    this.listen();
  }

  @Override(BaseBPProfilesDetailComponent)
  public listen():void {
    super.listen();

    this.onEditingChangeSubscription = this.invoiceTemplatesService.onEditingChange
      .pipe(distinctUntilChanged(_.isEqual))
      .subscribe((isEditing:boolean) => {
        this.bpProfilesService.editingMode = isEditing;
      });

    this.onFormChangeSubscription = this.invoiceTemplatesService.onFormChange.subscribe((form:UntypedFormGroup) => this.customFormState = form);

    this.onStateExitHook = this.transitionService.onExit({}, this.backToOverview);
  }

  @Override(BaseBPProfilesDetailComponent)
  public onEditChange(isEdit:boolean):void {
    this.invoiceTemplatesService.editing = isEdit;

    if (!isEdit && !this.isSaving) {
      this.eventService.sendMessage(EVENT_CANCEL_BP_INVOICE_TEMPLATE);
    } else {
      this.eventService.sendMessage(EVENT_EDIT_BP_INVOICE_TEMPLATE, this.invoiceTemplatesService.editing);
    }
  }

  protected onSave = ():void =>{
    this.onSavedDeferred = this.deferredService.defer();
    this.eventService.sendMessage(EVENT_SAVE_BP_INVOICE_TEMPLATE); // notify component invoice-template-detail about the save event

    this.setSaveBusy(true);
    this.onSavedDeferred.promise
      .catch(this.emitErrorSaving)
      .finally(() => {
        this.setSaveBusy(false);
      });
  };

  public onInvoiceTemplateSaved():void {
    this.onSavedDeferred.resolve();
  }

  public onInvoiceTemplateCancel():void {
    this.onSavedDeferred.reject();
  }

  @Override(BaseBPProfilesDetailComponent)
  public ngOnDestroy():void {
    super.ngOnDestroy();
    this.onEditingChangeSubscription?.unsubscribe();
    this.onFormChangeSubscription?.unsubscribe();
    this.onStateExitHook();
  }
}